import languageAnimation from '@/assets/lottie/Language.json';
import loadingAnimation from '@/assets/lottie/Loading.json';
import speechAnimation from '@/assets/lottie/Speech.json';
import voiceAnimation from '@/assets/lottie/Voice.json';

/**
 * Перенос `lib/src/config/lottie_assets.dart`.
 *
 * В Dart `Lottie.asset(path)` сам читал файл по пути. `lottie-web` так не
 * умеет: он принимает либо `path` (тогда это лишний сетевой запрос), либо
 * уже разобранный объект в поле `animationData`. Поэтому JSON импортируется
 * напрямую — Vite вшивает его в бандл, и анимация стартует без запроса.
 */

/** Разобранные данные анимации — поле `animationData` в `lottie-web`. */
export type LottieAnimationData = Record<string, unknown>;

export type LottieAssetName = 'language' | 'voice' | 'speech' | 'loading';

export const LottieAssets: Readonly<
  Record<LottieAssetName, LottieAnimationData>
> = Object.freeze({
  language: languageAnimation,
  voice: voiceAnimation,
  speech: speechAnimation,
  loading: loadingAnimation,
});
